import React, { useState } from 'react';

import Form from 'react-bootstrap/Form';
import './QueryDetails.css';

const BasicDetails = (props) => {
  return (
    <>
    <div className="caseQueryTit">Basic Keyword</div>
    <div className="basicQuery">
      <ul>
        <li>
          <div className="andOrNot">and</div>
          <div className="andOrNotQuery">
            <Form>
              <Form.Control id="queryDetailInput" as="textarea" onChange={props.handleAndString} plaintext={!props.editable} readOnly={!props.editable} value={props.andString} rows={4} />
            </Form>
          </div>
        </li>
        <li>
          <div className="andOrNot">or</div>
          <div className="andOrNotQuery">
            <Form>
              <Form.Control id="queryDetailInput" as="textarea" onChange={props.handleOrString} plaintext={!props.editable} readOnly={!props.editable} value={props.orString} rows={4} />
            </Form>
          </div>
        </li>
        <li>
          <div className="andOrNot">not</div>
          <div className="andOrNotQuery">
            <Form>
              <Form.Control id="queryDetailInput" as="textarea" onChange={props.handleNotString} plaintext={!props.editable} readOnly={!props.editable} value={props.notString} rows={4} />
            </Form>
          </div>
        </li>
      </ul>
    </div>
    </>
  )
}

const BooleanDetails = (props) => {
  return (
    <>
      <div className="caseQueryTit">Boolean Keyword</div>
      <div className="booleanQueryBg">
        <div className="booleanQueryTxt">
          <Form>
            <Form.Control id="queryDetailInput" as="textarea" onChange={props.handleBooleanQuery} plaintext={!props.editable} readOnly={!props.editable} value={props.booleanQuery} rows={11} />
          </Form>
        </div>
      </div>
    </>
  )
}
const QueryDetails = (props) => {
  const handleResultBtn = () => {
    if (props.queryInfo.QUERY_TYPE=="BASIC"){
      const body = {
        "query" : {
          "and": props.andString,
          "or": props.orString,
          "not": props.notString
        },
        "type" : "BASIC",
        "dateRange" : [props.dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"}), props.dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})]      
      }
      return props.handleResultBtn("/search/query-content", body, props.resultData);
    }
    else if (props.queryInfo.QUERY_TYPE=="BOOLEAN"){
      const body = {
        "query" :{
          "boolQuery": props.booleanQuery
        },
        "type": "BOOLEAN",
        "dateRange" : [props.dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"}), props.dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})]
      }
      return props.handleResultBtn("/search/query-content", body, props.resultData);
    }
  }


  const DetailsBtns = (props) => {
    if( props.editable ){
      return (
        <div className="manageQueryBtn">
          <a className="button purple_line" onClick={()=>{
            if (props.queryInfo.QUERY_TYPE == 'BOOLEAN'){
              props.handleSaveBtn({"boolQuery":props.booleanQuery}, props.queryInfo.queryID, props.queryInfo.QUERY_TYPE);
            }
            else if (props.queryInfo.QUERY_TYPE == 'BASIC'){
              props.handleSaveBtn({
                "and": props.andString.split(/\s*(?:,|$)\s*/).filter(item=>item!=""),
                "or": props.orString.split(/\s*(?:,|$)\s*/).filter(item=>item!=""),
                "not": props.notString.split(/\s*(?:,|$)\s*/).filter(item=>item!="")
              }, props.queryInfo.queryID, props.queryInfo.QUERY_TYPE);
            }
            }}>저장</a>
          &nbsp;
          <a className="button purple_line" onClick={()=>props.handleCancelBtn(props.queryInfo)}>취소</a>
        </div>
      )
    }
    else {
      return (
        <div className="manageQueryBtn">
          <a className="button purple" onClick={handleResultBtn}>결과보기</a>
          &nbsp;
          <a className="button purple_line" onClick={()=>props.handleEditable(true)}>수정</a>
          &nbsp;
          <a className="button purple_line" onClick={()=>props.handleRemoveBtn(props.queryInfo.queryID)}>삭제</a>
        </div>
      )
    }
  }

  return (
    <>
      <div className="caseQuery">
        {
          props.queryInfo.QUERY_TYPE ? 
            props.queryInfo.QUERY_TYPE === "BOOLEAN" ?
              <BooleanDetails booleanQuery={props.booleanQuery} handleBooleanQuery={props.handleBooleanQuery} editable={props.editable}/>
              : <BasicDetails andString={props.andString} orString={props.orString} notString={props.notString} handleAndString={props.handleAndString} handleOrString={props.handleOrString} handleNotString={props.handleNotString} editable={props.editable} />
          : undefined
        }
      </div>
      <DetailsBtns handleRemoveBtn={props.handleRemoveBtn} handleEditable={props.handleEditable} andString={props.andString} orString={props.orString} notString={props.notString} booleanQuery={props.booleanQuery} queryInfo={props.queryInfo} handleCancelBtn={props.handleCancelBtn} editable={props.editable} handleSaveBtn={props.handleSaveBtn}/>
    </>
  )
}

export default QueryDetails;